import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema4/GLB_T4_Moneda.glb";
import { GUI } from "dat.gui";
import gsap from "gsap";

export class GoldCoin extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		// this.helpers()

	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Moneda = gltf.scene.getObjectByName("Moneda", true);
		})
	}
	helpers() {
		const gui = new GUI();
		const escanerFolder = gui.addFolder("Moneda");
		escanerFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		escanerFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		escanerFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		escanerFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		escanerFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		escanerFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		escanerFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale x");
		escanerFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale y");
		escanerFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale z");
		escanerFolder.add(this, "visible").name("visible");
	}
	onAnimate() {
		this.clearAnimation()
		this.Moneda.animation = gsap.to(this.Moneda.rotation, {
			x: 1,
			y: 4.6,
			z: 1.58,
			yoyo: true,
			repeat: -1,
			duration: 5,
			ease: "none",
		});
	}
	clearAnimation() {
		if (this.Moneda.animation) {
			this.Moneda.animation.kill();
			this.Moneda.rotation.set(0, 0, 0)
		}
	}
}